import React from "react";
import { Card, CardContent, Typography } from "@mui/material";

export default function TelemetryError({ message }) {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 4,
        border: "1px solid #fecaca",
        bgcolor: "#fff7f7",
      }}
    >
      <CardContent>
        <Typography sx={{ color: "#b91c1c", fontWeight: 800, mb: 1 }}>
          Failed to load telemetry
        </Typography>
        <Typography sx={{ color: "#7f1d1d" }}>
          {message || "Something went wrong"}
        </Typography>
      </CardContent>
    </Card>
  );
}